document.addEventListener('change', event => {
  if (!event.target.matches('.cbl-product-form input[name="id"]')) return;
  const card = event.target.closest('.cbl-card');
  card.querySelector('[data-cbl-price]').textContent = event.target.dataset.price;
  const compare = card.querySelector('[data-cbl-compare]');
  compare.textContent = event.target.dataset.compare || '';
  compare.hidden = !event.target.dataset.compare;
  const discount = card.querySelector('[data-cbl-discount]');
  if (discount) {
    const percent = event.target.dataset.discount;
    discount.textContent = percent ? `-${percent}%` : '';
    discount.hidden = !percent;
  }
});
